"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YesNoFieldView = void 0;
var input_state_1 = require("../../../components/input/input.state");
var switch_input_1 = require("../../../components/input/switch.input");
var i18n_1 = require("../../../i18n");
exports.YesNoFieldView = {
    viewInline: function (field) {
        return (0, i18n_1.Translate)(field.value ? i18n_1.T.YES : i18n_1.T.NO);
    },
    viewDetail: function (field) {
        return null;
    },
    viewEdit: function (field, ctrl) {
        var inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new input_state_1.InputState(field.schema.displayName);
            inputState.onValue(function () { return field.Mutator.manual(inputState.value); });
            inputState.setValue(field.value);
            ctrl.changeState.addState(field.id, inputState);
        }
        return switch_input_1.SwitchInput.view(inputState);
    },
    hasClear: function (field) {
        return false;
    }
};
//# sourceMappingURL=yesno.field.view.js.map